import { computed } from "vue";
import { useUserStore } from "@erp/shared/stores/user.store";
import { storeToRefs } from "pinia";
/**
 * @description 로그인한 유저 정보를 제공하는 컴포저블
 */
export function useLoginInfo() {
    const userStore = useUserStore();
    const { user } = storeToRefs(userStore);
    const userData = {
        id: computed(() => user?.value?.id || -1),
        userName: computed(() => user?.value?.userName || ""),
        givenName: computed(() => user?.value?.givenName || ""),
        email: computed(() => user?.value?.email || ""),
        position: computed(() => {
            const pos = user?.value?.position;
            if (typeof pos === "string") {
                try {
                    return JSON.parse(pos).name || "";
                }
                catch {
                    return "";
                }
            }
            return pos?.name || "";
        }),
        department: computed(() => {
            const dept = user?.value?.department;
            if (typeof dept === "string") {
                try {
                    return JSON.parse(dept).name || "";
                }
                catch {
                    return "";
                }
            }
            return dept?.name || "";
        }),
        phoneNumber: computed(() => user?.value?.phoneNumber || ""),
        officePhoneNumber: computed(() => user.value?.officePhoneNumber || ""),
        officeInternalNumber: computed(() => user.value?.internalNumber || ""),
    };
    return { userData, ...userData };
}
